import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-permission-settings',
  templateUrl: './permission-settings.component.html',
  styleUrls: ['./permission-settings.component.scss']
})
export class PermissionSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
